import { coreFollowsRoute } from '@/modules/library/domain/routes/libraryRoutes';
import { requestQuery } from '@/services/request';
import { ProgramFollows } from '@/types';

export const getProgramFollows = () =>
  requestQuery<ProgramFollows>({
    url: coreFollowsRoute,
  });
